<template>
  <div class="text-center">
    <v-dialog
        v-model="visible"
        width="500"
    >
      <v-card>
        <dialog-header :title="$t('entitySelect.selectFromList')" :close="close"/>

        <v-card-text>
          <v-text-field v-model="searchTerm"
                        @input="searchTermUpdated"
                        outlined
                        prepend-inner-icon="mdi-magnify"
                        clearable
                        hide-details
                        autocomplete="false"
                        :autofocus="$vuetify.breakpoint.name !== 'xs'"
                        :loading="loading"
                        class="mt-4"
                        :placeholder="$t('entitySelect.search')"/>

          <v-list style="max-height: 40em">
            <slot v-for="item in items"
                  name="listItem"
                  :item="item"/>
          </v-list>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              text
              @click="close"
          >
            {{ $t('actions.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import DialogHeader from '@/components/layouts/DialogHeader';
export default {
  name: 'EntitySelectDialog',
  components: { DialogHeader },
  props: {
    search: { required: true },
    loading: { required: true },
    items: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    visible: false,
    searchTerm: '',
    timerId: null,
  }),

  methods: {
    show() {
      this.searchTerm = '';
      this.search(this.searchTerm);
      this.visible = true;
    },

    close() {
      this.visible = false;
    },

    searchTermUpdated() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      this.timerId = setTimeout(() => {
        this.search(this.searchTerm);
      }, 500);
    },
  },
};
</script>

<style scoped>

</style>

